import { cn } from "@/utils/theme";
import { useWorkflowStore } from "@/workflow_api/store/workflowStore";
import type { NodeData } from "@/workflow_api/types/workflow";
import { Icon } from "@elaniintc/goes-design-system";
import { VariableKeyBox } from "../key-box";

interface Props {
  id: string;
}

const Content = ({ data }: { data: NodeData }) => {
  if (!data) {
    return (
      <Icon
        name="spinner-third"
        className="animate-spin text-sm text-on-disabled"
        type="far"
      />
    );
  }

  const outputValue = data?.inputs.find((i) => i.name === "output_name")?.value;

  // Parse the output name - it can be an object {base: string} or a JSON string
  let parsedName = "documento";
  try {
    if (
      typeof outputValue === "object" &&
      outputValue !== null &&
      "base" in outputValue
    ) {
      parsedName = (outputValue as { base: string }).base || "documento";
    } else if (typeof outputValue === "string") {
      const parsed = JSON.parse(outputValue);
      parsedName = parsed.base || "documento";
    }
  } catch {
    parsedName = typeof outputValue === "string" ? outputValue : "documento";
  }

  return (
    <div className="flex">
      <div
        className={cn(
          "w-0.5 relative translate-x-[25px]",
          "bg-neutral-object-accent",
        )}
      >
        <span className="absolute left-3 top-[14px] w-2 h-2 bg-neutral-object-accent rounded-full"></span>
        <span className="absolute w-3 h-5 border-l-2 border-t-2 border-neutral-object-accent rotate-x-180 rounded-tl-md"></span>
      </div>

      <div className="relative pl-[50px] mb-4 w-full">
        <div className="py-1">
          <div className="space-y-3">
            <VariableKeyBox name={parsedName} type={"file"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export const DocGeneratorVariables = ({ id }: Props) => {
  const { getNodeById } = useWorkflowStore();
  const node = getNodeById(id);
  if (!node) return <></>;
  const nodeData = node.data as unknown as NodeData;
  return <Content data={nodeData} />;
};
